/* eslint-disable react/style-prop-object */
import { ListWrapper } from "../../styles/StyledComponents/ListWrapper";
import {
  DetailsWrapper,
  ServiceTabCompWrapper,
} from "../../styles/StyledComponents/ServiceTabCompWrapper";
import assests from "../../ui/assests";
import DetailsArrowIcon from "../../ui/icons/DetailsArrowIcon";
import { viewDesignList } from "../../ui/json/demo.mock";

const ServiceTabComp = () => {
  return (
    <ServiceTabCompWrapper>
      <figure className="services_tabImg">
        <img src={assests.services_tabImg} alt="services_tabImg" />
      </figure>
      <div className="tab_details_wrap">
        <h3>UI/UX Design</h3>
        <p>
          Transform your online presence with our exceptional, stunning UI/UX
          design services. Our expert designers are fully equipped with the
          tools and strategies to create visually appealing and user-centered
          designs. We aim to drive engagement levels and enhance your customer
          experience.
        </p>
        <ListWrapper>
          {viewDesignList?.map((data, index) => (
            <>
              <li key={index}>{data}</li>
            </>
          ))}
        </ListWrapper>
        <DetailsWrapper>
          <button>View Details</button>
          <i>
            <DetailsArrowIcon />
          </i>
          <div className="btn_embeded">
            <svg
              style={{ visibility: "hidden", position: "absolute" }}
              width="0"
              height="0"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
            >
              <defs>
                <filter id="goo">
                  <feGaussianBlur
                    in="SourceGraphic"
                    stdDeviation="10"
                    result="blur"
                  ></feGaussianBlur>
                  <feColorMatrix
                    in="blur"
                    mode="matrix"
                    values="1 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 19 -10"
                    result="goo"
                  ></feColorMatrix>
                  <feComposite
                    in="SourceGraphic"
                    in2="goo"
                    operator="atop"
                  ></feComposite>
                </filter>
              </defs>
            </svg>
          </div>
        </DetailsWrapper>
      </div>
    </ServiceTabCompWrapper>
  );
};

export default ServiceTabComp;
